import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Electron loads via file:// which breaks BrowserRouter (pathname is the full file path).
// HashRouter works correctly with file:// URLs.
declare const __ELECTRON__: boolean | undefined
const isElectron = typeof __ELECTRON__ !== 'undefined' && (__ELECTRON__ as any) === true
const Router = isElectron ? HashRouter : BrowserRouter

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Router>
            <App />
        </Router>
    </StrictMode>,
)
